import type {Network} from '@cohort/shared/schema/common/blockchain';

export function blockchainExplorerUrl(network: Network): string {
  switch (network) {
    case 'local':
      return 'http://embed-test.localhost/echo';
    case 'polygon-mumbai':
      return 'https://mumbai.polygonscan.com';
    case 'polygon':
      return 'https://polygonscan.com';
  }
}
